<script>
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import {
  CommentsWidgetElementMixin,
} from "%/dynamic-component-editor/standard-elements/comments-widget/comments-widget-element-mixin";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";

export default {
  name: "CancelCommentButton",
  extends: BaseButtonElement,
  mixins: [CommentsWidgetElementMixin],
  elementPanelSettings: {
    displayName: "Cancel Comment",
    displayIcon: "button",
    elementGroup: "commentWidgetElements",
    elementType: "element",
  },
  optionBundles: [
    new ButtonOptions({
      "default.text-option": "Cancel",
      "default.icon": "",
    }, {
      "button-action": true,
      "link-type": true,
      "href-option": true,
    }),
  ],
  computed: {
    ...mapState(useConfigurationStore, ["canCommentOnPosts"]),
    shouldRenderButton() {
      return this.editMode || this.canCommentOnPosts;
    },
  },
  methods: {
    handleButtonClick() {
      if (!this.showsSampleComments) {
        this.storyComments.clearComposer(this.storyEntityId);
      }
    },
  },
};
</script>
